export const getMsgValues = (items: { [key: string]: () => string }): string[] => {
  const valuesArray = Object.keys(items).map((key) => {
    return items[key]();
  });
  return valuesArray;
};

export const formatNumber = (value: number): string => {
  return value.toLocaleString('fi-FI', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatNumberWithoutDecimals = (value: number): string => {
  return value.toLocaleString('fi-FI', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const increaseRoundedValue = (
  currentValue: number,
  stepAmount: number,
): number => {
  return Math.floor(currentValue / stepAmount) * stepAmount + stepAmount;
};

export const decreaseRoundedValue = (
  currentValue: number,
  stepAmount: number,
): number => {
  return Math.ceil(currentValue / stepAmount) * stepAmount - stepAmount;
};
